import {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  teal,
  yellow,
} from "@mui/material/colors";
import { sumBy } from "./arrayHelper";

export const accessCategoryTagColors: Record<string, string> = {
  blueGrey600: blueGrey[600],
  blueGrey500: blueGrey[500],
  brown400: brown[400],
  deepOrange800: deepOrange[800],
  deepOrange700: deepOrange[700],
  orange900: orange[900],
  amber900: amber[900],
  yellow900: yellow[900],
  amber800: amber[800],
  yellow800: yellow[800],
  lime900: lime[900],
  lime800: lime[800],
  lightGreen700: lightGreen[700],
  green700: green[700],
  lightGreen800: lightGreen[800],
  teal600: teal[600],
  cyan800: cyan[800],
  cyan700: cyan[700],
  lightBlue700: lightBlue[700],
  blue700: blue[700],
  lightBlue800: lightBlue[800],
  indigo400: indigo[400],
  indigo300: indigo[300],
  deepPurple300: deepPurple[300],
  deepPurple400: deepPurple[400],
  purple400: purple[400],
  pink600: pink[600],
  pink500: pink[500],
};

const accessCategoryTagColorValues = Object.values(accessCategoryTagColors);

export const getCategoryColorFromNameHash = (categoryName: string): string => {
  const stringHash = sumBy(categoryName.split(""), (ch) => ch.charCodeAt(0));
  return accessCategoryTagColorValues[stringHash % accessCategoryTagColorValues.length] || grey[600];
};

const getConfiguredCategoryTagColor = (tagColorKey?: string): string | undefined =>
  tagColorKey && Object.hasOwn(accessCategoryTagColors, tagColorKey) ? accessCategoryTagColors[tagColorKey] : undefined;

const defaultCategoryTagColor = green[700];

export const getCategoryTagColor = (tagColorKey: string | undefined): string =>
  getConfiguredCategoryTagColor(tagColorKey) || defaultCategoryTagColor;
